import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { RoleGroupApiService } from '../CommonController/role-group-service';
import { SharedValidators } from '../shared/validators/shared-validators';
import e from 'express';

@Component({
  selector: 'app-roles-group-page',
  templateUrl: './roles-group-page.component.html',
  styleUrl: './roles-group-page.component.scss',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    DatePipe,
    MatIcon,
    CommonSearchComponent,
    CommonPaginationComponent,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
  ],
})
export class RolesGroupPageComponent implements OnInit {
  pageNo = 1;
  pageSize = 10;
  totalItems = 0;
  listOfRoleGroup = [];
  searchText = '';
  roleType = '';
  isAddRoleGroup = false;
  isRoleGroupAddForm = true;

  addRoleGroupForm!: FormGroup;
  groupId = 0;

  userPermissions = [];
  userRoleGroupView = false;
  userRoleGroupCreate = false;
  userRoleGroupUpdate = false;
  userRoleGroupDelete = false;

  constructor(
    private formBuilder: FormBuilder,
    public commonApiService: CommonApiService,
    public roleGroupApiService: RoleGroupApiService,
    private spinner: NgxSpinnerService,
    public router: Router
  ) {}

  ngOnInit() {
    this.checkPermission();
    this.setRoleGroupForm();
    if (this.userRoleGroupView) {
      this.fetchRoleGroupList();
    }
  }

  checkPermission() {
    this.roleType = sessionStorage.getItem('roleType') || '';
    this.userPermissions = JSON.parse(
      sessionStorage.getItem('userPermissions') || '[]'
    );
    if (this.roleType == 'Super Administrator') {
      this.userRoleGroupView = true;
      this.userRoleGroupCreate = true;
      this.userRoleGroupUpdate = true;
      this.userRoleGroupDelete = true;
    } else {
      this.navigateBack();
    }
    this.userPermissions.forEach((element: any) => {
      if (element.pageName === 'Role Group' && element.view === false) {
        this.navigateBack();
      }
      if (element.pageName === 'Role Group' && element.view === true) {
        this.userRoleGroupView = true;
      }
      if (element.pageName === 'Role Group' && element.create === true) {
        this.userRoleGroupCreate = true;
      }
      if (element.pageName === 'Role Group' && element.update === true) {
        this.userRoleGroupUpdate = true;
      }
      if (element.pageName === 'Role Group' && element.delete === true) {
        this.userRoleGroupDelete = true;
      }
    });
  }

  setRoleGroupForm() {
    this.addRoleGroupForm = this.formBuilder.group({
      id: [0],
      groupName: [
        '',
        [
          SharedValidators.requiredAndNoEmptySpaces,
          SharedValidators.nonNumericNoSpecialChars,
        ],
      ],
    });
  }

  fetchRoleGroupList() {
    this.spinner.show();
    this.roleGroupApiService
      .getAllRoleGroup(this.pageNo - 1, this.pageSize, this.searchText)
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.listOfRoleGroup = res.data;
          this.totalItems = res.totalItems;
        },
        error: (ERROR: HttpErrorResponse) => {
          this.listOfRoleGroup = [];
          this.spinner.hide();
          this.commonApiService.openSnackbar(ERROR.error.message);
        },
      });
  }

  saveRoleGroup() {
    if (this.addRoleGroupForm.invalid) {
      this.addRoleGroupForm.get('groupName')?.markAsTouched();
      return;
    }

    this.spinner.show();
    const payload = this.addRoleGroupForm.value;
    payload.id = 0;
    this.roleGroupApiService.addRoleGroup(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
          this.isAddRoleGroup = false;
          this.ngOnInit();
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  fetchDataById(id: number) {
    this.roleGroupApiService.getSingleGroup(id).subscribe({
      next: (res) => {
        if (res.status) {
          const data = res.data;
          this.isRoleGroupAddForm = false;
          this.addRoleGroupForm = this.formBuilder.group({
            groupName: new FormControl(data.groupName, [
              SharedValidators.requiredAndNoEmptySpaces,
              SharedValidators.nonNumericNoSpecialChars,
            ]),
            updatedAt: new Date(),
          });
          this.groupId = data.id;
          this.addRoleGroup('update');
        } else {
          this.commonApiService.openSnackbar('Operation Failed');
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  addRoleGroup(operationType: any) {
    if (operationType === 'add') {
      this.groupId = 0;
      this.addRoleGroupForm.reset();
      this.isRoleGroupAddForm = true;
    } else {
      this.isRoleGroupAddForm = false;
    }
    this.isAddRoleGroup = true;
  }

  updateRoleGroup() {
    if (this.addRoleGroupForm.invalid) {
      SharedValidators.markAllAsTouched(this.addRoleGroupForm);
      return;
    }

    this.spinner.show();
    const payload = this.addRoleGroupForm.value;
    payload.id = this.groupId;
    this.roleGroupApiService.updateRoleGroup(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.isRoleGroupAddForm = false;
          this.commonApiService.openSnackbar(res.message);
          this.spinner.hide();
          this.isAddRoleGroup = false;
          this.ngOnInit();
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar('Operation Failed');
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  deleteRoleGroup(id: string) {
    if (confirm('Are you sure? Do you want to delete')) {
      this.spinner.show();
      this.roleGroupApiService.deleteRoleGroup(id).subscribe({
        next: (res) => {
          if (res.status) {
            this.commonApiService.openSnackbar(res.message);
            this.spinner.hide();
            this.ngOnInit();
          } else {
            this.spinner.hide();
            this.commonApiService.openSnackbar('Operation Failed');
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.commonApiService.openSnackbar(ERROR.error.message);
        },
      });
    }
  }

  onPageChange(event: any) {
    this.pageNo = event;
    this.fetchRoleGroupList();
  }

  onSizeChange(pageSize: any): void {
    this.pageSize = pageSize; // Update the pageSize
    this.pageNo = 1; // Reset to the first currentPage
    sessionStorage.setItem('pageSize', this.pageSize.toString());
    this.fetchRoleGroupList();
  }

  onSearchRoleName(event: string) {
    this.searchText = event;
    this.pageNo = 1;
    this.fetchRoleGroupList();
  }

  changePage() {
    this.isAddRoleGroup = false;
    this.fetchRoleGroupList();
  }

  onClickAddRoleRefresh() {
    this.fetchRoleGroupList();
    if (this.groupId === 0) {
      this.addRoleGroupForm.reset();
    } else {
      this.fetchDataById(this.groupId);
    }
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
